import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

const IndexPage = () => {

    return <>
        <section id="hero" className="d-flex align-items-center justify-content-center">
            <div className="container text-center" data-aos="zoom-in" data-aos-delay="100">
                <h1 className="text-white fw-bold display-4 mb-2">Bimal Adhikari</h1>

                <h2 className="text-white-50 fs-4 mb-4 fw-light mx-auto">
                    PhD Student at the <span className="text-white fw-semibold">University of Arkansas</span>
                    <br className="d-none d-md-inline" />
                    Specializing in RF Fingerprinting & Physical-Layer Wireless Security
                </h2>

                <div className="d-flex justify-content-center gap-3 flex-wrap">
                    <Nav.Link as={Link} to="/about" className='btn-about'>About me</Nav.Link>
                    <Nav.Link as={Link} to="/resume" className='btn-about bg-white text-dark'>View Resume</Nav.Link>
                </div>
            </div>
        </section>
        
    </>
};

export default IndexPage;